import { Text } from '@bancobarigui/barihaus';
import { formatarMoeda, formatarNumero, calcularPercentual } from '../shared/formatters';
import * as styles from '../CardHomogeneizacao/styles';

interface LimiteDisplayProps {
  valor: number;
  base: number;
  tipo: 'superior' | 'inferior';
}

export function LimiteDisplay({ valor, base, tipo }: LimiteDisplayProps) {
  const simbolo = tipo === 'superior' ? '▲' : '▼';
  const percentual = calcularPercentual(valor, base);
  const percentualFormatado = tipo === 'superior'
    ? `(+${formatarNumero(percentual, 1)}%)`
    : `(${formatarNumero(percentual, 1)}%)`;

  return (
    <Text style={tipo === 'superior' ? styles.limiteSuperiorStyle : styles.limiteInferiorStyle}>
      {simbolo} {formatarMoeda(valor)}
      {base > 0 && (
        <Text type="secondary" style={styles.percentualStyle}>
          {percentualFormatado}
        </Text>
      )}
    </Text>
  );
}
